<template>
	<v-container>
		<v-row>
			<v-col cols="12">
			  <v-data-table
          :loading="loading" 
          loading-text="Cargando... Por favor espera"
			    :headers="headers"
			    :items="desserts"
			    sort-by="calories"
			    class="elevation-1"
			    >
			    <template v-slot:top>
			      <v-toolbar flat color="white">
			        <v-toolbar-title>Categorías</v-toolbar-title>
			        <v-divider
			          class="mx-4"
			          inset
			          vertical
			        ></v-divider>
			        <v-spacer></v-spacer>
			        <v-dialog v-model="dialog" max-width="500px">
			          <template v-slot:activator="{ on, attrs }">
			            <v-btn
                    rounded
			              color="primary"
			              dark
			              class="mb-2"
			              v-bind="attrs"
			              v-on="on"
                    small
			            >Nueva categoría</v-btn>
			          </template>
			          <v-card>
			            <v-card-title>
			              <span class="headline">{{ formTitle }}</span>
			            </v-card-title>

			            <v-card-text>
			              <v-container>
			                <v-row>
			                  <v-col cols="12" sm="6" md="4">
			                    <v-text-field readonly v-model="editedItem.idcategoria" label="Id"></v-text-field>
			                  </v-col>
			                  <v-col cols="12" >
                          <v-text-field v-model="editedItem.nomcatego" label="Categoría"></v-text-field>
                          <div>Ejemplo: 2019 - 2020</div>
                        </v-col>
			                </v-row>
			              </v-container>
			            </v-card-text>

			            <v-card-actions>
			              <v-spacer></v-spacer>
			              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
			              <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
			            </v-card-actions>
			          </v-card>
			        </v-dialog>
			      </v-toolbar>
			    </template>
			    <template v-slot:item.actions="{ item }">
			      <v-icon
              color="primary"
			        small
			        class="mr-2"
			        @click="editItem(item)"
			      >
			        mdi-pencil
			      </v-icon>
			      <!-- <v-icon
              color="primary"
			        small
			        @click="deleteItem(item)"
			      >
			        mdi-delete
			      </v-icon> -->
			    </template>
			    <template v-slot:no-data>
			      <v-btn color="primary" @click="initialize">Reset</v-btn>
			    </template>
			  </v-data-table>
			</v-col>
		</v-row>
	</v-container>
</template>


<script>
  export default {
    data: () => ({
      loading: true,
      id:0,
      dialog: false,
      headers: [
        {
          text: 'Id',
          align: 'start',
          sortable: false,
          value: 'idcategoria',
        },
        { text: 'Categoría', value: 'nomcatego' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        idcategoria: 0,
        nomcatego: '',
      },
      defaultItem: {
        idcategoria: 0,
        nomcatego: '',
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nueva Categoría' : 'Editar Categoría'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.$http.get('clasificacion.categorias').then(response=>{
          this.desserts = response.body
          this.loading = false
        }).catch(error=>{console.log(error)})
      },

      editItem (item) {
        this.id = item.idcategoria
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.desserts.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (this.editedIndex > -1) {
          this.$http.put('clasificacion.categoria.update/' + this.id, this.editedItem).then(response=>{
            this.initialize()
          }).catch(error=>{console.log(error)})
        } else {
          this.$http.post('clasificacion.categoria.add', this.editedItem).then(response=>{
            this.initialize()
          }).catch(error=>{console.log(error)})
          // this.desserts.push(this.editedItem)
        }
        this.close()
      },
    },
  }
</script>